import styled, { css } from 'styled-components'
import { ProductCardLab } from '@sainsburys-tech/bolt'

export default styled(ProductCardLab)`
  :nth-child(n) {
    border: 0;
    padding: 15px 0;
    padding-bottom: 30px;
  }

  :nth-child(n + 4) {
    border-top: 1px solid ${props => props.theme.tokens.color.monochrome.light};
  }

  @media (max-width: ${props => props.theme.screen_xs_max}) {
    max-width: calc(50% - 22.5px);

    :nth-child(n) {
      padding-bottom: 15px;
    }

    :nth-child(n + 3) {
      border-top: 1px solid ${props => props.theme.tokens.color.monochrome.light};
      padding-bottom: 15px;
    }

    :nth-child(odd) {
      margin-left: 15px;
      margin-right: 7.5px;
    }

    :nth-child(even) {
      margin-left: 7.5px;
      margin-right: 15px;
    }
  }
  ${props =>
    props.isM053 &&
    css`
      :nth-child(n) {
        padding: 0;
        border: 0;
      }
    `}
  ${props =>
    props.isCarousel &&
    css`
      :nth-child(n) {
        padding: 0;
        border: 0;
        margin: inherit;
        max-width: 100%;
      }
    `}

  ${props =>
    props.brandTheme === 'habitat' &&
    css`
      .btn-cta {
        width: 100%;
        margin-right: 0;
      }
    `}
`
